import React from "react";
import { Navigate, useParams } from "react-router-dom";

import { CurrentClientProvider } from "hooks/api/use-clients";
import { useClient } from "hooks/api/use-clients";
import { ClientEmailWriterPollingProvider } from "hooks/client-email-writer-polling-provider";

import { Route } from "utilities/app-routes";

const ClientProvider = ({ children }: React.PropsWithChildren) => {
  const { clientId } = useParams<{ clientId: string }>();
  const { data: client, isError } = useClient(clientId);

  if (isError) {
    return <Navigate to={Route.notFound} replace />;
  }

  return client && (!clientId || client.id === clientId) ? (
    <CurrentClientProvider client={client}>
      <ClientEmailWriterPollingProvider>{children}</ClientEmailWriterPollingProvider>
    </CurrentClientProvider>
  ) : null;
};

export default ClientProvider;
